<template>
    <div class="main-container">
        <div class="main-content">
            <StatusIndicator>
                <template #icon>
                    <PhWarningCircle :size="20" class="text-amber-400" />
                </template>
            </StatusIndicator>
            <div class="content">
                <!-- No license -->
                <div class="upper" v-if="!authStore.user?.license">
                    <div class="title">
                        <span>Let us handle it!</span>
                    </div>
                    <p>Get full automation and nonstop scanning across 1,000+ brokers! Subscribe now.</p>
                </div>
                <!-- Essentials license -->
                <div class="upper" v-else-if="authStore.user?.license?.name === 'essentials'">
                    <div class="title">
                        <span>Unlock this feature</span>
                    </div>
                    <p>Upgrade to add automated handling and always-on scanning across 1,000+ brokers.</p>
                </div>
                <!-- Other licenses -->
                <div class="upper" v-else>
                    <div class="title">
                        <span>We're on it!</span>
                    </div>
                    <p>Your license already handles this automatically! This is just info for non-licensed users.</p>
                </div>
            </div>
        </div>
        <PrimeButton
            v-if="authStore.user?.license?.name === 'essentials' || !authStore.user?.license"
            @click="openFeatureModal"
            :label="buttonLabel"
            class="w-full mt-4"
        />
        <FeatureLockedModal
            v-model="featureModalOpen"
            :mode="featureModalMode"
            feature="Automated Company Deletion"
        />
    </div>
</template>
<script setup lang="ts">
import StatusIndicator from '~/components/main/shared/StatusIndicator.vue';
import { useAuthStore } from '~/stores/auth';

const authStore = useAuthStore();

const { featureModalOpen, featureModalMode, openFeatureModal } = useFeatureLockedModal();

const buttonLabel = computed(() => {
    if (!authStore.user?.license) {
        return 'Protect Yourself';
    } else if (authStore.user?.license?.name === 'essentials') {
        return 'Upgrade License';
    }
    return 'Protect Yourself';
});
</script>
<style lang="scss" scoped>
.main-container {
    @apply flex-col py-4 pr-4 pl-6 border-b border-zinc-300;
}
.main-content {
    @apply flex gap-4;
}
.content {
    @apply flex flex-col items-start gap-3 flex-1;
}
.upper {
    @apply flex flex-col gap-0.5 items-start flex-1 w-full;

    p {
        @apply text-zinc-700 font-inter text-sm font-normal leading-5;
    }
}
.title {
    @apply flex justify-between items-center w-full;

    span {
        @apply text-zinc-950 font-inter text-sm font-semibold leading-5;
    }
}
.dont-show {
    @apply text-zinc-600 font-inter text-sm font-semibold leading-5;
}
</style>
